import React, { useEffect, useState } from 'react';
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    hh: Math.floor(seconds / 3600),
    mm: Math.floor(seconds % 3600 / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-31" data-mp="3h0z2wwv6xgxl">
      <div className="flex h-16 w-16 items-center justify-center rounded-xl border border-gold/25 bg-ink font-display text-3xl font-black tabular-nums text-white sm:h-20 sm:w-20 sm:text-4xl" data-id="element-32" data-mp="3h1qttudueqhj">
        {String(value).padStart(2, '0')}
      </div>
      <span className="mt-2 text-[10px] font-bold uppercase tracking-widest text-white/50" data-id="element-33" data-mp="10cbsrg76aze9">
        {label}
      </span>
    </div>;
}
export function Countdown() {
  const {
    hh,
    mm,
    ss
  } = useCountdown(23 * 3600 + 59 * 60 + 44);
  return <section aria-label="Cuenta regresiva" className="bg-ink" data-id="element-34" data-mp="xzvipeo9v61p">
      <div className="mx-auto max-w-3xl px-5 pt-[28px] text-center" data-id="element-35" data-mp="t2d4b8rhjymb">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold" data-id="element-36" data-mp="szzd5azxf6k1">
          ⏰ Precio de lanzamiento — cierra pronto
        </p>
        <div className="mt-6 flex items-center justify-center gap-3 sm:gap-5" data-id="element-37" data-mp="12rmyqv9sxtdl">
          <Unit value={hh} label="Horas" data-id="element-38" data-mp="f22f0a5tqs39" />
          <span className="font-display text-3xl font-black text-white/30" data-id="element-39" data-mp="f33selabbqo5">:</span>
          <Unit value={mm} label="Min" data-id="element-40" data-mp="a40stgd3qcnk" />
          <span className="font-display text-3xl font-black text-white/30" data-id="element-41" data-mp="a5c03q5ra2jf">:</span>
          <Unit value={ss} label="Seg" data-id="element-42" data-mp="o4k02l9qteoo" />
        </div>
        <p className="mt-6 text-sm font-semibold text-white/60" data-id="element-43" data-mp="k0vto5wukp50">
          ⚠️ Después sube $35.000 ARS. No vuelve a este precio.
        </p>

        <div className="mx-auto mt-8 max-w-md" data-id="element-44" data-mp="1zgkt4cdn3pa8">
          <p className="mb-2 text-left text-xs font-semibold text-white/60" data-id="element-45" data-mp="1vgu7en2yzzck">
            🔴 Cupos al precio de lanzamiento
          </p>
          <div className="h-3 w-full overflow-hidden rounded-full bg-white/10" data-id="element-46" data-mp="s4v7fgn7xcgm">
            <div className="h-full w-[68%] rounded-full bg-celeste" data-id="element-47" data-mp="x3yfl9yhvyst" />
          </div>
          <p className="mt-2 text-right text-xs font-bold text-gold" data-id="element-48" data-mp="1244108e68p2g">68% tomados — Quedan pocos</p>
        </div>
      </div>
    </section>;
}